import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { DataStorageService } from 'src/app/core/services/data-storage.service';
import { SectionService } from 'src/app/core/services/section.service';
import { SidebarService } from 'src/app/core/services/sidebar.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  sidebarState: boolean;
  selectedCompany: string = '';

  constructor(
    private sidebarService: SidebarService,
    public sectionService: SectionService,
    private dataStorageService: DataStorageService,
    private authService: AuthenticationService
  ) {
    console.log('header');

    this.sidebarState = false;
    this.authService.sidebarVisibilityChange.subscribe(value => {
      let currentUser = JSON.parse(this.dataStorageService.getStorage('HTHSelectedCompany'));
      console.log(currentUser);
      if (currentUser) {
        this.selectedCompany = currentUser[0].DBName;
      }
    });
    this.toggleSidebar();
  }


  ngOnInit(): void {
    let currentUser = JSON.parse(this.dataStorageService.getStorage('HTHSelectedCompany'));
    console.log(currentUser);
    if (currentUser) {
      this.selectedCompany = currentUser[0].DBName;
    }
  }

  toggleSidebar() {
    this.sidebarState = !this.sidebarState;
    this.sidebarService.toggler.next(this.sidebarState);
  }
}
